const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const R2_URL = process.env.REACT_APP_R2_URL;

export { BACKEND_URL, API, R2_URL };
